export const formattedNumberOfEvents = (locale, amount): string =>
  new Intl.NumberFormat(locale).format(amount)
